window.$mm_budget_result = [];
window.$mm_budget_treeChangeStatus = false;
window.$mm_budget_page_number = 1;
window.$mm_budget_Glist = [];
window.$mm_budget_selectedRow = "";
window.$mm_budget_content = [];
window.$mm_budget_lastUsedTableFilter = [];
window.$mm_budget_scroll_change = false;
window.$mm_budget_filterClickStatus = false;
window.$mm_budget_filterLastIds = [];
window.$mm_budget_searchInputId = null;
window.$mm_budget_columnList = [];
window.$mm_budget_plannigAlgemeenGisratio = [];
window.$mm_budget_plannigStatus = [];
window.$mm_budget_maatregelNaam = [];
window.$mm_budget_werkplanNaam = [];
window.$mm_budget_planningspatroonNaam = [];
window.$mm_budget_planningsperiodeNaam = [];
window.$mm_budget_budgetNaam = [];
window.$mm_budget_beheereenheidNaam = [];
window.$mm_budget_beheeractiviteitLaag = [];
window.$mm_budget_disciplineNaam = [];
window.$mm_budget_statusTijdstipVerzonden = [];
window.$mm_budget_filterCheckControlGPlannig = [false, false];
window.$mm_budget_gvv = 1;
window.$mm_budget_last_search_id = "";
window.$mm_budget_table_total_row_count = 0;
window.$mm_budget_columnListPure = null;
window.$mm_budget_refresh = function (){};
window.$mm_budget_filterCheckControl = [
  ["status-detailplanning", false, false],
  ["status-budget", false, false],
  ["status-uitvoering", false, false],
  ["status-werkplan", false, false],
  ["planning-iscorrectiefonderhoud", false, false],
  ["status-verzonden", false, false],
];
window.$mm_budget_filterClickControl = [
  ["status-detailplanning", false],
  ["status-budget", false],
  ["status-uitvoering", false],
  ["status-werkplan", false],
  ["planning-iscorrectiefonderhoud", false],
  ["status-verzonden", false],
];
window.$mm_budget_filterContent = [
  { key: "budget-naam", and_or: "AND", values: [], datatype: "STRING" },
];
window.$mm_budget_actions = [
  {
    id: "57d136a2-9749-46d4-85c4-edda4de75409",
    text: "Plaats in budget",
    class: "locate",
    modal: "plaats_in_budget",
  },
  {
    id: "1041f11d-46f4-4a46-a1c5-8e6d91f0877f",
    text: "Plaats in werkplan",
    class: "locate",
    modal: "plaats_in_werkplan",
  },
  {
    id: "3a98846b-67c1-4192-9edc-b980f10898b8",
    text: "Wijzig status",
    class: "locate",
    modal: "wijzig_status",
  },
  {
    id: "f666587d-18e8-4760-8b73-089be562cde0",
    text: "Verwijder uit budget",
    class: "locate",
    modal: "budget_verwijder_uit_budget",
  },
  {
    id: "bu_toon_dossiers_op_kaart",
    text: "bu_toon_dossiers_op_kaart",
    class: "locate",
    modal: "",
  },
];

window.$mm_budget_column_order_post_model = {
  client_identification: "",
  code: "",
  data: {
    table_sorting: [
      {
        name: "management-maintenance>budget",
        column_list: [
          "checkbox",
          "active",
          "status_detailplanning",
          "status_budget",
          "status_uitvoering",
          "status_werkplan",
          "planning_iscorrectiefonderhoud",
          "status_verzonden",
          "Gisratio Id",
          "Status",
          "Naam maatregel",
          "Naam budget",
          "Naam discipline",
          "Naam werkplan",
          "Datum aangemaakt",
          "Datum laatst gewijzigd",
        ],
      },
    ],
  },
};
